"use strict";var dd=require("../core");require("../platform"),module.exports=dd;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/entry/union.js
// module id = 1108
// module chunks = 106